export default "__VITE_ASSET__BpsM1D57__"